import { InputComponentProps } from "./Filters";
import { useEffect, useState } from "react";
import { Display_Value_Key as dvk } from "../Create/utils";

// Text input component
const RenderTextInput: React.FC<InputComponentProps> = ({
  filter,
  onChange,
  preSelected,
  onApplyStateChange,
}) => {
  const [textInput, setTextInput] = useState<string>("");

  const handleOnApply = () => {
    const textInputList = textInput.trim();
    onChange(filter.name, textInputList, textInput);
    // onChange(filter.name, textInput, textInput);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && textInput) {
      handleOnApply();
    }
  };

  useEffect(() => {
    if (preSelected[filter.name]) {
      setTextInput(preSelected[filter.name + dvk]);
    }
  }, []);

  // Update apply state whenever textInput changes
  useEffect(() => {
    if (onApplyStateChange) {
      onApplyStateChange(!textInput, handleOnApply, "Apply");
    }
  }, [textInput, onApplyStateChange]);

  return (
    <div className="px-3">
      <div className="mb-3 py-3 border-bottom">
        <div className="f-14 mb-1">{filter.suffix}</div>
        <input
          type="text"
          className="table_filter_text_input form-control form-control-sm"
          value={typeof textInput === "string" ? textInput : String(textInput)}
          onChange={(e) => setTextInput(String(e.target.value))}
          onKeyDown={handleKeyDown}
        />
      </div>
    </div>
  );
};

export default RenderTextInput;
